// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { createApp } from "vue";
import * as Vue from "vue";
import { createVfm } from "vue-final-modal";
import "vue-final-modal/style.css";

// Import base styles first (Bootstrap and other libraries)
import "bootstrap/dist/css/bootstrap.css";

// Import fonts after base styles
import "@/assets/styles/fonts.css";

// Import custom styles last to override base styles
import "../static/style.css";

import App from "./App";
import router from "./router";
import store from "./store/index.js";
import util from "./mixins/globalUtilityMixin";
import MixpanelMixin from './mixins/MixpanelMixin'
import VueFroala from "./vue-froala"

import {
  library
} from "@fortawesome/fontawesome-svg-core";
import {
  faHome,
  faEllipsisV,
  faCog,
  faComment,
  faTimes,
  faSearch,
  faCircle,
  faInfo,
  faInfoCircle,
  faExternalLinkAlt,
  faExclamationTriangle,
  faCheckCircle,
  faFile,
  faEnvelope,
  faLink,
  faBookmark,
  faArrowLeft,
  faChevronLeft,
  faChevronRight,
  faTrash,
  faStar,
  faEye,
  faCalendarAlt,
  faReply
} from "@fortawesome/free-solid-svg-icons";

import {
  FontAwesomeIcon,
  FontAwesomeLayers
} from "@fortawesome/vue-fontawesome";

import {
  faComment as farComment,
  faComments as farComments,
  faEye as farEye,
  faTimesCircle as farTimesCircle,
  faStar as farStar
} from "@fortawesome/free-regular-svg-icons";

// Import Froala Editor js files
import "froala-editor/js/froala_editor.pkgd.min";
import "froala-editor/js/plugins/file.min.js";
import "froala-editor/css/plugins/file.css";

// Import Froala Editor css files
import "froala-editor/css/froala_editor.pkgd.min.css";

import "font-awesome/css/font-awesome.css";
import "froala-editor/css/froala_style.min.css";
import "@/custom_module/plugins/css/froala-bootstrap-grid.plugin.css";
import "@/custom_module/plugins/js/froala-bootstrap-grid.plugin.js";

library.add(faHome, faEllipsisV, faCog, faComment, faTimes, faSearch, faCircle, faExternalLinkAlt, faInfo, faInfoCircle, faExclamationTriangle, faCheckCircle, faFile, farComment, farComments, farEye, farTimesCircle, faEnvelope, faLink, faBookmark, faArrowLeft, faChevronLeft, faChevronRight, faTrash, faStar, farStar, faEye, faCalendarAlt, faReply);

// Expose FontAwesome globally so all bundles can share the same icon registry
window.FontAwesomeLibrary = library;
window.FontAwesomeIcon = FontAwesomeIcon;
window.FontAwesomeLayers = FontAwesomeLayers;

// Expose Vue globally for web components
window.Vue = Vue;


// Load web component library after Vue is available
(function() {
  let headElement = document.getElementsByTagName("head")[0];
  let newElement = document.createElement("script");
  let date = new Date();
  let oneHourCache = date.getMonth()+1+""+date.getDate()+""+date.getFullYear()+""+date.getHours();
  // let oneHourCache = date.getTime();
  newElement.src = HH_COMPONENTS_URL + "/helphubcore.umd.min.js?v="+oneHourCache;

  newElement.onload = function() {
    // Web component library loaded successfully
  };

  newElement.onerror = function(error) {
    console.error('[main.js] ❌ Failed to load web component library:', error);
  };

  headElement.appendChild(newElement);

  var componentStyleElement = document.createElement("link");
  componentStyleElement.type = "text/css";
  componentStyleElement.rel = "stylesheet";
  componentStyleElement.href = HH_COMPONENTS_URL + "/theme.css";
  headElement.appendChild(componentStyleElement);  
})();

/* eslint-disable no-new */
const app = createApp(App);


// Create vue-final-modal instance
const vfm = createVfm();

// Apply mixins
app.mixin(util);
app.mixin(MixpanelMixin);

// Use plugins
app.use(VueFroala);
app.use(vfm);
app.use(router);
app.use(store);

// Register global components
app.component("font-awesome-icon", FontAwesomeIcon);
app.component('font-awesome-layers', FontAwesomeLayers);

// Mount the app after router is ready
router.isReady().then(() => {
  app.mount("#app");
});